import { useCallback, useState } from 'react';

import { useParams } from 'react-router-dom';

import useFeatureFlags from 'api/useFeatureFlags';
import { EFeatureFlag } from 'constants/enums';

interface IUseRollingOfferCheatsReturn {
  cheatsOfferId: string | null;
  hasFeatureFlagCheats: boolean;
  onOpenCheats: (offerId: string) => void;
  handleCloseCheats: () => void;
}

/**
 * Encapsulates cheats-related state and feature flag logic
 * for the Rolling Offers table.
 *
 * @example
 * const { cheatsOfferId, hasFeatureFlagCheats, onOpenCheats, handleCloseCheats } =
 *   useRollingOfferCheats();
 */
export const useRollingOfferCheats = (): IUseRollingOfferCheatsReturn => {
  const { publisherId } = useParams();
  const { featureFlags } = useFeatureFlags({ publisherId });

  const [cheatsOfferId, setCheatsOfferId] = useState<string | null>(null);

  const hasFeatureFlagCheats = !!featureFlags?.[EFeatureFlag.DASHBOARD_ROLLING_CHEATS];

  const handleCloseCheats = useCallback((): void => {
    setCheatsOfferId(null);
  }, []);

  const onOpenCheats = useCallback((offerId: string): void => {
    setCheatsOfferId(offerId);
  }, []);

  return {
    cheatsOfferId,
    hasFeatureFlagCheats,
    onOpenCheats,
    handleCloseCheats
  };
};
